<div class="row">
  <div class="col-md-6">
    <fieldset style="border: 0">
      <form #FreshWaterDeliveryNote="ngForm" class="form-horizontal">
        <div class="card shadow-sm">
          <div class="card-body">

            <!-- Fresh Water Delivery Note No. -->
            <div class="row mb-3">
              <div class="col-12">
                <app-material-pg-input
                  label="Fresh Water Delivery Note NO"
                  type="text"
                  name="number"
                  id="number"
                  tabindex="1"
                  [disabled]="edit"
                  [(ngModel)]="freshWaterDeliveryNote.bdnNumber"
                  [required]="true">
                </app-material-pg-input>
              </div>
            </div>

            <!-- Location -->
            <div class="row mb-3">
              <div class="col-12">
                <app-material-organisation-selector
                  id="location"
                  class="pg-component"
                  [(ngModel)]="selectedPortOrganisation"
                  [organisationLanguage]="'en'"
                  name="location"
                  [organisations]="ports"
                  tabindex="2"
                  [placeholder]="'Location'"
                  [disabled]="edit"
                  [required]="true">
                </app-material-organisation-selector>
              </div>
            </div>

            <!-- Date -->
            <div class="row mb-3">
              <div class="col-12">
                <app-material-offset-date-time
                  label="Date"
                  type="date"
                  name="date"
                  [(ngModel)]="freshWaterDeliveryNote.date"
                  [zoneId]="selectedPortOrganisation?.timezone"
                  [(ngModel)]="freshWaterDeliveryNote.date"
                  [disabled]="edit || !selectedPortOrganisation"
                  [required]="true">
                </app-material-offset-date-time>
              </div>
            </div>

            <!-- Supplier & Vessel -->
            <div class="row mb-3">
              <div class="col-md-6">
                <app-material-auto-complete
                  name="vessel"
                  id="vessel"
                  [formatter]="vesselFormatter"
                  [(ngModel)]="selectedVessel"
                  [items]="vessels"
                  [placeholder]="'Vessel'"
                  [required]="true"
                  tabindex="4">
                </app-material-auto-complete>
              </div>

              <div class="col-md-6">
                <app-material-organisation-selector
                  id="supplier"
                  class="pg-component"
                  [disabled]="edit"
                  [(ngModel)]="selectedSupplierOrganisation"
                  [organisationLanguage]="'en'"
                  name="supplier"
                  [organisations]="supplier"
                  [placeholder]="'Supplier'"
                  [required]="true"
                  tabindex="5" >
                </app-material-organisation-selector>
              </div>
            </div>

            <!-- Quantity -->
            <div class="row mb-3">
              <div class="col-12">
                <app-material-pg-input
                  label="Quantity"
                  type="number"
                  name="quantity"
                  id="quantity"
                  [(ngModel)]="freshWaterDeliveryNote.quantity"
                  tabindex="6"
                  [required]="true">
                </app-material-pg-input>
              </div>
            </div>

            <!-- File Upload -->
            <div class="row mb-3">
              <div class="col-12">
                <app-material-chunk-file-uploader
                  [accept]="'.pdf'"
                  id="fdnFile"
                  name="fdnFile"
                  [(ngModel)]="doc"
                  (ngModelChange)="uploadFDNFile($event)"
                  [required]="!freshWaterDeliveryNote.fileId"
                  tabindex="7">
                </app-material-chunk-file-uploader>
              </div>
            </div>

            <!-- Buttons -->
            <div class="row mt-4">
              <div class="col-12 d-flex justify-content-end">
                <app-material-pg-button
                  id="delete"
                  class="me-2"
                  (clicked)="remove()"
                  label="Remove">
                </app-material-pg-button>
                <app-material-pg-button
                  id="save"
                  [disabled]="!FreshWaterDeliveryNote.form.valid && !valid"
                  (clicked)="save()"
                  label="Save">
                </app-material-pg-button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </fieldset>
  </div>

  <!-- PDF Viewer -->
  <div class="col-md-6">
    @if(freshWaterDeliveryNote && freshWaterDeliveryNote.fileId){
      <app-material-pdf-viewer
        [fileId]="freshWaterDeliveryNote.fileId">
      </app-material-pdf-viewer>
    }
  </div>
</div>
